import script from "./accordion.vue?vue&type=script&setup=true&lang=js"
export * from "./accordion.vue?vue&type=script&setup=true&lang=js"

import "./accordion.vue?vue&type=style&index=0&id=92af46e2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-92af46e2"]])

export default __exports__